import { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { RoutePath } from "@/section/router";

export function DocumentsQueueDashboard() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname === RoutePath.DocumentsQueue) {
      navigate(RoutePath.DocumentsQueueOtc, { replace: true });
    }
  }, [location.pathname, navigate]);

  return (
    <div className="flex h-full max-h-[95vh] flex-col gap-4 overflow-hidden">
      <div className="flex items-center gap-2">
        <Button
          variant="ghost"
          className={cn(
            "h-auto p-0 text-xl font-bold hover:bg-transparent",
            location.pathname.startsWith(RoutePath.DocumentsQueueOtc)
              ? "text-foreground"
              : "text-muted-foreground hover:text-foreground",
          )}
          onClick={() => navigate(RoutePath.DocumentsQueueOtc)}
        >
          OTC
        </Button>
        <span className="text-xl font-bold text-muted-foreground">/</span>
        <Button
          variant="ghost"
          className={cn(
            "h-auto p-0 text-xl font-bold hover:bg-transparent",
            location.pathname.startsWith(RoutePath.DocumentsQueueNightly)
              ? "text-foreground"
              : "text-muted-foreground hover:text-foreground",
          )}
          onClick={() => navigate(RoutePath.DocumentsQueueNightly)}
        >
          Nightly
        </Button>
        <span className="text-xl font-bold text-muted-foreground">/</span>
        <Button
          variant="ghost"
          className={cn(
            "h-auto p-0 text-xl font-bold hover:bg-transparent",
            location.pathname.startsWith(RoutePath.DocumentsQueueDeferredPayment)
              ? "text-foreground"
              : "text-muted-foreground hover:text-foreground",
          )}
          onClick={() => navigate(RoutePath.DocumentsQueueDeferredPayment)}
        >
          Deferred Payment Contracts
        </Button>
      </div>
      <div className="flex-1 overflow-auto">
        <Outlet />
      </div>
    </div>
  );
}
